export const movePointsConstants = {
	MOVE_POINTS: 'MOVE_POINTS',
	POINTS_MOVED: 'POINTS_MOVED',
	UPDATE_SENDER: 'UPDATE_SENDER',
	UPDATE_RECEIVER: 'UPDATE_RECEIVER',
	UPDATE_POINTS_TO_BE_MOVED: 'UPDATE_POINTS_TO_BE_MOVED',
	ADD_OPTIONS: 'ADD_OPTIONS'
}
